<cva-common-dialog [title]="historicalData.title" [headerIcon]="dialogHeaderIcon" [id]="historicalData.patientId"
  [indentifier]="manualRefreshIdentifier" [refreshIcon]="false" [headerClass]="dialogHeaderClass"
  class="historical-data" (dataFetched)="patchRefreshedData($event)">
  <div class="hd-content-wrapper" [ngClass]="dialogContentClass">
    <div *ngIf="loading" class="modal-loader-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
    <ng-container *ngIf="!loading">
      @if (showPreviousconsultation){
      @if(consultationHistoryCurPage.length >0){
      <div class="consultation-history-container">
        @for (history of consultationHistoryCurPage; track history) {
        <div class="consultation-history-entry mb-10">
          <div class="consultation-note-preview-card" *ngIf="hasConsultationPreviewText(history)">
            <div class="consultation-note-date">{{history.soapNoteDate | date : 'd MMM, y'}}</div>
            @if (isConsultationNoteExpanded(history)) {
            <p class="consultation-note-full-text">{{ getConsultationPreviewText(history) }}</p>
            } @else {
            <p class="consultation-note-preview-text">{{ getConsultationPreviewText(history) }}</p>
            }
            <button type="button" class="consultation-note-toggle" *ngIf="hasFormattedConsultationNote(history)"
              (click)="toggleConsultationNoteExpanded(history)">
              {{ isConsultationNoteExpanded(history) ? 'Less' : 'More' }}
            </button>
          </div>
        </div>
        }
      </div>
      <div class="hd-modal-footer" *ngIf="consultationHistory.length > consultationHistoryPageSize || showViewMoreBtn">
        <mat-paginator #paginator *ngIf="consultationHistory.length > consultationHistoryPageSize"
          class="demo-paginator" (page)="handleConsultationHistoryPageEvent($event)"
          [length]="consultationHistory.length" [pageSize]="consultationHistoryPageSize"
          [pageIndex]="consultationHistoryPageIndex" [showFirstLastButtons]="true" [hidePageSize]="true">
        </mat-paginator>
        <button *ngIf="showViewMoreBtn" (click)="getMedicalSummaryData()" class="btn btn-dark btn-sm ">
          View More
        </button>
      </div>
      }@else{
      <div class="no-records-found">
        <strong> No Record Found. </strong>
      </div>
      }
      }@else if (showMedicationRequestData) {
      @if (medicalRequestCurPage.length) {
      <div class="medication-expanded-table-wrap">
        <table class="medication-expanded-table">
          <thead>
            <tr>
              <th>DATE</th>
              <th>MEDICATION</th>
              <th>QTY</th>
              <th>DURATION</th>
              <th>ROUTE</th>
              <th>INSTRUCTION</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of medicalRequestCurPage">
              <ng-container *ngFor="let row of item.table; let rowIdx = index">
                <tr>
                  <td class="medication-date-cell" *ngIf="rowIdx === 0" [attr.rowspan]="item.table.length">
                    {{ item.date | date:'dd-MMM-yyyy' }}
                  </td>
                  <td>{{ (row.medication | titlecase) || '-' }}</td>
                  <td>{{ row.qty || '-' }}</td>
                  <td>{{ row.duration || '-' }}</td>
                  <td>{{ row.route || '-' }}</td>
                  <td>{{ row.instruction || '-' }}</td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="hd-modal-footer" *ngIf="medicalRequestData.length > medicationRequestPageSize || showViewMoreBtn">
        <mat-paginator #paginator class="demo-paginator" *ngIf="medicalRequestData.length > medicationRequestPageSize"
          (page)="handleMedicationRequestPageEvent($event)" [length]="medicalRequestData.length"
          [pageSize]="medicationRequestPageSize" [pageIndex]="medicationRequestPageIndex" [showFirstLastButtons]="true"
          [hidePageSize]="true">
        </mat-paginator>
        <button *ngIf="showViewMoreBtn" (click)="getMedicationRequestData()" class="btn btn-dark btn-sm "> View
          More</button>
      </div>
      }@else {
      <div class="no-records-found">
        <strong> No Record Found. </strong>
      </div>
      }
      } @else if (showLabHistory) {
      @if (labDataArray?.length) {
      <div class="lab-test-search-wrap">
        <input id="lab-test-search-input" type="text" class="lab-test-search-input" placeholder="Search test name"
          [(ngModel)]="labTestSearchTerm" />
      </div>

      @if (hasActiveLabSearch()) {
      @if (getFilteredLabEntries().length) {
      <div class="lab-filtered-results-list">
        <div class="lab-filtered-result-card" *ngFor="let entry of getFilteredLabEntries(); let i = index">
          <div class="lab-date-title">{{ entry.date }}</div>
          <div class="lab-selected-test">{{ entry.displayName }}</div>
          <div *ngFor="let html of entry.resultData" [innerHTML]="getSafeHTML(html)"></div>
        </div>
      </div>
      } @else {
      <div class="no-records-found">
        <strong> No matching lab results found. </strong>
      </div>
      }
      } @else {
      <div class="lab-results-chip-layout">
        <div class="lab-date-card" *ngFor="let item of labResultsPage; let idx = index">
          <div class="lab-date-header-row">
            <div class="lab-date-title">{{ item.date }}</div>
            <div class="lab-result-chip-row" *ngIf="item.entries.length">
              <button type="button" class="lab-result-chip" *ngFor="let entry of item.entries; let j = index"
                [class.active]="selectedLabEntryByDate[item.date] === j" (click)="selectLabEntry(item.date, j)">
                {{ entry.displayName }}
              </button>
            </div>
          </div>

          <div class="lab-result-details" *ngIf="getSelectedLabEntry(item) as selectedEntry">
            <div class="lab-selected-test">{{ selectedEntry.displayName }}</div>
            <div *ngFor="let html of selectedEntry.resultData" [innerHTML]="getSafeHTML(html)"></div>
          </div>
        </div>
      </div>
      }

      <div class="hd-modal-footer">
        <mat-paginator *ngIf="!hasActiveLabSearch() && (labDataArray?.length || 0) > labResultsPageSize" #paginator
          class="demo-paginator" (page)="handleLabResultsPageEvent($event)" [length]="labDataArray?.length"
          [pageSize]="labResultsPageSize" [pageIndex]="labResultsPageIndex" [showFirstLastButtons]="true"
          [hidePageSize]="true">
        </mat-paginator>
      </div>
      }@else {
      <div class="no-records-found">
        <strong> No Record Found. </strong>
      </div>
      }
      }@else {
      @if (columns.length === 1) {
      <div class="no-records-found">
        <strong> No Record Found. </strong>
      </div>
      }@else {
      <cva-data-table [displayedColumns]="columns" [tableData]="tableData" tableClass="mat-elevation-z1"
        [isToTitleCaseColumn]="shouldApplyTitleCase('status')" [stickyColumnIndex]="stickyColumnPosition"
        [showPagination]="historicalData.category === 'Observations' ? false : showPagination" [hidePageSize]="true"
        [pageSize]="pageSize"></cva-data-table>
      <div class="hd-modal-footer obs-view-more-footer"
        *ngIf="historicalData.category === 'Observations' && showViewMoreBtn">
        <button (click)="getVitalSignsData()" class="btn btn-dark btn-sm ">
          View More
        </button>
      </div>
      }
      }
    </ng-container>
  </div>